<style scoped="scoped" lang="scss">
.efficiency-monthly {
  .panel {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    background: #f7f8fa;
    color: #909399;
    height: 28px;
    line-height: 28px;
    // min-width: 1000px;
    width: 100%;
    flex-shrink: 0;

    // 效率信息说明
    .info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: nowrap;
      background: #f7f8fa;
      color: #909399;
      height: 28px;
      line-height: 28px;
      // min-width: 1000px;
      width: 100%;
      flex-shrink: 0;

      .info-item-1 {
        max-width: 300px;
        min-width: 280px;
        height: 28px;
        flex-shrink: 0;
      }

      .info-item-2 {
        max-width: 280px;
        height: 28px;
        flex-shrink: 0;
      }

      .info-item-3 {
        width: 100%;
        text-align: right;
        color: #419fff;
        display: flex;
      }
    }
  }

  // 效率表单
  .form {
    margin-top: 12px;

    // 标记点
    .percent-box {
      margin-top: 8px;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      min-width: 1000px;
      flex-wrap: wrap;

      .percent-input {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
      }

      .percent-input1 {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        margin-left: 35px;
      }

      .border {
        // border: 1px solid #E5E5E5;
        width: 60px;
        height: 28px;
        border-radius: 5px;
        margin-left: 12px;
        text-align: center;
      }

      .mark {
        font-family: Microsoft YaHei UI;
        font-size: 14px;
        color: #606266;
      }

      .border:focus {
        outline: none;
        border: 1px solid rgb(65, 159, 255);
      }

      .text-word {
        font-family: Microsoft YaHei UI;
        font-size: 14px;
        color: #606266;
        margin-left: 26px;
      }

      .percent {
        display: flex;
        flex-wrap: nowrap;
        color: #4d4d4d;
        margin-left: 12px;
      }
    }
  }

  // 总体指标
  .sum-target {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    // 左侧
    .left {
      display: flex;
      align-items: center;

      .icon {
        display: inline-block;
        width: 5px;
        height: 16px;
        background: #419fff;
      }

      .txt {
        display: inline-block;
        font-weight: 400;
        font-size: 16px;
        color: #303133;
        margin-left: 12px;
      }
    }

    // 右侧
    .right {
      display: flex;
      align-items: center;
    }
  }

  // 总体开机率/稼动率
  .summary {
    margin-top: 8px;
    height: 80px;
    width: 460px;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    border: 1px solid #e4e7ed;

    .summary-item {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-left: 20px;

      .summary-item-title {
        width: 80px;
        font-size: 16px;
        font-weight: 400;
        color: #303133;
      }

      .summary-item-value {
        width: 79px;
        margin-left: 20px;
        font-weight: 400;
        font-size: 24px;
        color: #606266;

        .summary-item-value-rate {
          font-size: 16px;
        }
      }
    }
  }

  // 详细指标
  .detail-target {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    // 左侧
    .left {
      display: flex;
      align-items: center;

      .icon {
        display: inline-block;
        width: 5px;
        height: 16px;
        background: #419fff;
      }

      .txt {
        display: inline-block;
        font-weight: 400;
        font-size: 16px;
        color: #303133;
        margin-left: 12px;
      }
    }

    // 右侧
    .right {
      display: flex;
      align-items: center;
    }
  }

  // 图表和表格
  .echart-table {
    margin-top: 8px;
    margin-bottom: 119px;
  }

  // 报表详情
  .report-detail {
    // 说明
    .target {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-left: 40px;
      margin-right: 40px;

      // 左侧
      .left {
        display: flex;
        align-items: center;

        .icon {
          display: inline-block;
          width: 5px;
          height: 16px;
          background: #419fff;
        }

        .txt {
          display: inline-block;
          font-weight: 400;
          font-size: 16px;
          color: #303133;
          margin-left: 12px;
        }
      }

      // 右侧
      .right {
        display: flex;
        align-items: center;
      }
    }

    // 表格
    .table {
      margin: 8px 40px 76px 40px;
    }
  }
}
</style>
<template>
  <div class="efficiency-monthly">
    <div class="panel" v-loading="searchLoading">
      <!-- 信息说明 -->
      <div class="info">
        <div class="info-item-1">
          {{ $t('kaijilugongshi') }}
        </div>
        <div class="info-item-2">
          {{ $t('jiadonglugongshi') }}
        </div>
        <div class="info-item-3">
          <div style="flex: 1; text-align: right;">{{ $t('meiri9:00gengxinzuorishuju') }}</div>
          <div style="margin-left: 20px;" v-if="utils.checkPower('web_report_mes_produce_report_efficiency_monthly_refresh')">
            <el-button size="mini" @click="refresh" type="primary">{{ $t('jishishengchengshangyirishuju') }}</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 搜索表单 -->
    <div class="form">
      <div ref="search1">
        <el-form size="mini" :style="{ height: screenWidth > 1232 ? '28px' : '' }" :inline="true" :model="equipmentReport.searchForm">
          <el-form-item :label="$t('xuanzeyuefen')">
            <el-date-picker v-model="equipmentReport.searchForm.summaryDate" type="month" value-format="yyyy-MM" placeholder="选择月"> </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :ids.sync="equipmentReport.searchForm.temp" :idsPath.sync="equipmentReport.searchForm.orgId" @change="listByOrgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="equipmentReport.searchForm.equipmentId"> </yi_data_select>
            <!--						<yi_cross_select multiple :component="'web_base_equipment_list'"-->
            <!--							:ids.sync="equipmentReport.searchForm.equipmentId">-->
            <!--						</yi_cross_select>-->
          </el-form-item>
          <el-form-item :label="$t('banci')">
            <el-select multiple v-model="equipmentReport.searchForm.shiftId" :placeholder="$t('qingxuanze')" clearable filterable :disabled="equipmentReport.searchForm.orgId.length === 0">
              <el-option v-for="item in shiftList" :key="item.id" :label="item.name + ' (' + item.code + ')'" :value="item.id">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.code }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" @click="getReport" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button size="mini" @click="reset">
              {{ $t('chongzhi') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 标记点 -->
      <div class="percent-box">
        <div class="mark">{{ $t('biaojidian') }}</div>
        <div class="percent-input">
          <div class="text-word">{{ $t('jiadongluxiaoyu') }}</div>
          <!-- <input class="border" v-model="jiadongRate" /> -->
          <el-input-number size="mini" class="border" @change="jiadongRateChange" :controls="false" :min="1" :max="100" v-model="jiadongRate"> </el-input-number>
          <span class="percent">%</span>
        </div>
        <div class="percent-input1">
          <div class="text-word">{{ $t('kaijiluxiaoyu') }}</div>
          <!-- <input class="border" v-model="startUpRate" /> -->
          <el-input-number size="mini" class="border" @change="startUpRateChange" :controls="false" :min="1" :max="100" v-model="startUpRate"> </el-input-number>
          <span class="percent">%</span>
        </div>
      </div>
    </div>
    <!-- 标题 -->
    <div class="sum-target">
      <div class="left">
        <span class="icon"></span>
        <span class="txt">{{ $t('zongtizhibiao') }}</span>
      </div>
      <div class="right"></div>
    </div>
    <!-- 总体开机率/稼动率 -->
    <div class="summary" v-loading="searchLoading">
      <div class="summary-item">
        <span class="summary-item-title">{{ $t('zongtikaijilu') }}</span>
        <span class="summary-item-value">{{ startUpSumRate }}<span class="summary-item-value-rate">%</span></span>
      </div>
      <div class="summary-item">
        <span class="summary-item-title">{{ $t('zongtijiadonglu') }}</span>
        <span class="summary-item-value">{{ jiadongSumRate }}<span class="summary-item-value-rate">%</span></span>
      </div>
    </div>
    <div class="detail-target">
      <div class="left">
        <span class="icon"></span>
        <span class="txt">{{ $t('xiangxizhibiao') }}</span>
      </div>
      <div class="right">
        <el-button size="mini" style="margin-right:15px" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportExcelEff()"> </el-button>
        <el-radio-group v-model="radio" size="mini" :border="true" :fill="fill" :text-color="textColor">
          <el-radio-button label="1">
            <i class="yicon yicon-numbers_line"></i>
          </el-radio-button>
          <el-radio-button label="2">
            <i class="yicon yicon-list_check"></i>
          </el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <!-- 图表和表格 -->
    <div class="echart-table">
      <!-- 图表 -->
      <div class="echart" v-show="radio == '1'">
        <div id="produceeReportMain" v-loading="searchLoading" style="height:400px;"></div>
      </div>
      <!-- 表格 -->
      <div class="table" v-show="radio == '2'">
        <el-table max-height="600" stripe :data="equipmentReport.tableData.slice((pagination.currentPage - 1) * pagination.pageSize, pagination.currentPage * pagination.pageSize)" :row-style="rowStyle" v-loading="searchLoading" :cell-style="cellStyle" size="mini" border style="width: 100%" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }" @header-dragend="headerDragend">
          <el-table-column v-for="(item, index) in equipmentReportColumn" :key="index" :prop="item.prop" :sortable="item.sortable" :sort-method="(a, b) => sortMethod(a, b, item.prop)" :label="$t(item.label)" :width="item.width" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column :label="$t('xiangqing')" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="showReportDetail(scope.row)">
                {{ $t('chakan') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px;display: flex; flex-direction: row-reverse">
          <el-pagination v-if="equipmentReport.tableData.length > 0" background size="mini" :current-page.sync="pagination.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size.sync="pagination.pageSize" layout="total,sizes,prev,pager,next" :total="equipmentReport.tableData.length" />
        </div>
      </div>
    </div>
    <!-- 报表详情 -->
    <el-drawer :visible.sync="reportDetail.dialog" :direction="reportDetail.direction" size="80%">
      <!-- 弹框标题 -->
      <div slot="title">
        <span style="font-size: 18px;font-weight: 400;margin-left:20px;color:#303133;">{{ $t(reportDetail.title) }}</span>
      </div>
      <div class="report-detail">
        <!-- 表头说明 -->
        <div class="target">
          <div class="left">
            <span class="icon"></span>
            <span class="txt">{{ $t('kaijilu') }}、{{ $t('jiadonglu') }}</span>
          </div>
          <div class="right"></div>
        </div>
        <!-- 图表 -->
        <div id="reportChartMain" style="height: 350px; width: 100%;"></div>
        <!-- 表头说明 -->
        <div class="target" style="margin-top:16px">
          <div class="left">
            <span class="icon"></span>
            <span class="txt">{{ $t('shijianfenbu') }}</span>
          </div>
          <div class="right"></div>
        </div>
        <!-- 表格 -->
        <div class="table">
          <el-table :data="reportDetail.tableData" border size="mini" :row-style="rowStyle" :cell-style="cellStyle" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }">
            <el-table-column v-for="(item, index) in reportDetail.tableColumn" :key="index" :prop="item.prop" :label="$t(item.label)" :sortable="item.sortable" :show-overflow-tooltip="true"> </el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/javascript">
const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
const current = year + '-' + month;

const startTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01';
const endTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
export default {
  name: 'web_report_producee_report_efficiency_monthly',
  components: {},
  data() {
    return {
      shiftList: [],
      pagination: {
        currentPage: 1,
        pageSize: 10
      },
      searchLoading: false,
      exportLoading: false,
      show: true,
      activeName: 'first',
      fildId: '',
      fildIds: '',
      timer: null,
      jiadongRateValue: '',
      startUpRateValue: '',
      fill: '#ECF5FF',
      textColor: '#419FFF',
      screenWidth: '', // 可视窗口的宽度
      jiadongRate: undefined, // 稼动率
      startUpRate: undefined, // 开机率
      startUpSumRate: 0,
      jiadongSumRate: 0,
      reportChart: null,
      produceeReportChart: null,
      radio: '2',
      // 效率月报报表
      equipmentReport: {
        tableData: [],
        tableColumn: [
          {
            prop: 'equipmentName',
            sortable: true,
            label: 'shebeimingcheng'
          },
          {
            prop: 'orgName',
            sortable: false,
            label: 'suoshuzuzhi'
          },
          {
            prop: 'shiftName',
            sortable: true,
            label: 'banci'
          },
          {
            prop: 'startupRateLabel',
            // sortable: 'custom',
            sortable: true,
            label: 'kaijilu'
          },
          {
            prop: 'runRateLabel',
            sortable: true,
            label: 'jiadonglu'
          },
          {
            prop: 'runDuraLabel',
            sortable: false,
            label: 'yunxingshijian(xiaoshi)'
          },
          {
            prop: 'idleDuraLabel',
            sortable: false,
            label: 'kongxianshijian(xiaoshi)'
          },
          {
            prop: 'errorDuraLabel',
            sortable: false,
            label: 'guzhangshijian(xiaoshi)'
          },
          {
            prop: 'shutdownDuraLabel',
            sortable: false,
            label: 'lixianshijian(xiaoshi)'
          }
        ],
        searchForm: {
          equipmentId: [],
          orgId: [],
          summaryDate: current,
          shiftId: []
        }
      },
      // 报表详情
      reportDetail: {
        dialog: false,
        direction: 'rtl',
        title: '报表详情',
        tableColumn: [
          {
            label: 'riqi',
            prop: 'specificDate',
            sortable: true // 开启排序
          },
          {
            label: 'kaijilu',
            prop: 'startupRateLabel',
            sortable: true
          },
          {
            label: 'jiadonglu',
            prop: 'runRateLabel',
            sortable: true
          },
          {
            label: 'yunxingshijian(xiaoshi)',
            prop: 'runDuraLabel',
            sortable: false
          },
          {
            label: 'kongxianshijian(xiaoshi)',
            prop: 'idleDuraLabel',
            sortable: false
          },
          {
            label: 'guzhangshijian(xiaoshi)',
            prop: 'errorDuraLabel',
            sortable: false
          },
          {
            label: 'lixianshijian(xiaoshi)',
            prop: 'shutdownDuraLabel',
            sortable: false
          }
        ],
        tableData: []
      },
      // 显示项
      showTableColumn: {
        dialog: false,
        title: 'peizhixianshilie',
        type: 'equipmentProduction',
        // 产品月报
        equipmentProduction: {
          show: [0, 1, 2],
          initShow: []
        }
      }
    };
  },
  mounted() {
    // 在组件挂载后从本地存储中获取缓存的值
    const jiadongRateValue = window.localStorage.getItem('jiadongRateNumberValue');
    if (jiadongRateValue !== null || jiadongRateValue !== '') {
      this.jiadongRateValue = parseFloat(jiadongRateValue);
      this.jiadongRate = this.jiadongRateValue;
    }
    const startUpRateValue = window.localStorage.getItem('startUpRateNumberValue');
    if (startUpRateValue !== null || startUpRateValue !== '') {
      this.startUpRateValue = parseFloat(startUpRateValue);
      this.startUpRate = this.startUpRateValue;
    }
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  activated() {
    this.resize();
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  watch: {
    radio(newValue, oldValue) {
      this.resize();
    }
  },
  computed: {
    equipmentReportColumn() {
      const column = this.equipmentReport.tableColumn;
      const name = 'producee_report_first';
      let colwidths = {};
      if (window.localStorage.getItem('colwidth_' + name)) {
        try {
          colwidths = JSON.parse(window.localStorage.getItem('colwidth_' + name));
        } catch (e) {
          window.localStorage.removeItem('colwidth_' + name);
        }
      }
      if (column.length > 0) {
        for (const i in column) {
          if (colwidths[this.$t(column[i]['label'])] !== undefined) {
            this.$set(column[i], 'width', colwidths[this.$t(column[i]['label'])]);
          }
        }
      }
      return column;
    }
  },
  created() {
    this.equipmentReport.searchForm.temp = this.store.state.organizations[0].id;
    setTimeout(() => {
      console.log('orgId:', this.equipmentReport.searchForm.orgId);
      this.getReport();
    }, 300);
  },
  methods: {
    // 查询客户所属组织关联的班次列表
    listByOrgId() {
      if (this.equipmentReport.searchForm.orgId.length === 0) {
        return;
      }
      const orgId = this.equipmentReport.searchForm.orgId[0];
      this.http
        .get('/web/setting/shift/listByOrgId?orgId=' + orgId)
        .then(res => {
          this.shiftList = res.data || [];
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    jiadongRateChange(value) {
      this.jiadongRate = value;
      this.jiadongRateValue = value; // 在 input 事件触发时更新缓存的值
      // 在本地存储中保存缓存的值
      window.localStorage.setItem('jiadongRateNumberValue', this.jiadongRateValue.toString());
      console.log('value222', value);
    },
    startUpRateChange(value) {
      this.startUpRate = value;
      this.startUpRateValue = value; // 在 input 事件触发时更新缓存的值
      // 在本地存储中保存缓存的值
      window.localStorage.setItem('startUpRateNumberValue', this.startUpRateValue.toString());
      console.log('value222', value);
    },
    // 行样式
    rowStyle({ row, rowIndex }) {
      let style = {
        height: '42px'
      };
      let rowStartUpValue = parseFloat(row.startupRateValue);
      let inputSartUpValue = this.startUpRate ? parseFloat(this.startUpRate) : 0.0;
      if (rowStartUpValue < inputSartUpValue) {
        style['background'] = '#FEF0F0';
        style['color'] = '#000';
      }
      let rowRunValue = parseFloat(row.runRateValue);
      let inputRunValue = this.jiadongRate !== undefined ? parseFloat(this.jiadongRate) : 0.0;
      if (rowRunValue < inputRunValue) {
        style['background'] = '#FEF0F0';
        style['color'] = '#000';
      }
      return style;
    },

    // 单元格样式
    cellStyle({ row, column }) {
      let style = {
        padding: '0'
      };
      if (column.property == 'runRateLabel') {
        let rowValue = parseFloat(row.runRateValue);
        let inputValue = this.jiadongRate !== undefined ? parseFloat(this.jiadongRate) : '';
        if (rowValue < inputValue) {
          style['color'] = 'red';
        }
      }
      if (column.property == 'startupRateLabel') {
        let rowValue = parseFloat(row.startupRateValue);
        let inputValue = this.startUpRate !== undefined ? parseFloat(this.startUpRate) : 0.0;
        if (rowValue < inputValue) {
          style['color'] = 'red';
        }
      }
      return style;
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        this.screenWidth = document.body.clientWidth;
        if (this.produceeReportChart != null) {
          this.produceeReportChart.resize();
        }
        if (this.reportChart != null) {
          this.reportChart.resize();
        }
      }, 500);
    },
    //效率月报排序
    sortMethod(a, b, prop) {
      // 开机率
      if (prop === 'startupRateLabel') {
        return a.startupRate - b.startupRate;
      }
      if (prop === 'runRateLabel') {
        return a.runRate - b.runRate;
      }
    },
    // 效率月报（包含图表和表格）
    async getReport() {
      this.searchLoading = true;
      this.jiadongSumRate = '0.0';
      this.resize();
      let requestParam = {};
      let param = [];
      for (let i in this.equipmentReport.searchForm) {
        if (this.equipmentReport.searchForm[i] != '' && this.equipmentReport.searchForm[i] != null) {
          let val = this.equipmentReport.searchForm[i];
          if (i == 'equipmentId') {
            val = this.equipmentReport.searchForm[i].join(',');
            param.push({
              field: 'equipmentId',
              opt: 'IN',
              val: val,
              type: 'S'
            });
          }
          if (i == 'summaryDate') {
            val = this.equipmentReport.searchForm[i].split('-').join('');
            param.push({
              field: 'summaryDate',
              opt: '=',
              val: val,
              type: 'S'
            });
          }
          if (i == 'orgId') {
            val = this.equipmentReport.searchForm[i].join(',');
            param.push({
              field: i,
              opt: 'IN',
              val: val,
              type: 'S'
            });
          }
          if (i == 'shiftId') {
            val = this.equipmentReport.searchForm[i].join(',');
            param.push({
              field: i,
              opt: 'IN',
              val: val,
              type: 'S'
            });
          }
        }
      }
      if (param.length > 0) {
        requestParam['columns'] = param;
      } else {
        requestParam['columns'] = [];
      }
      requestParam['code'] = 'equipment_basic_efficiency_report';
      let response = await this.http.post('/web/report/page?orderBy=sort,shiftName asc', requestParam);

      // 表格部分
      this.equipmentReport.tableData = response.data.rows;
      if (this.equipmentReport.tableData.length > 0) {
        for (let i = 0; i < this.equipmentReport.tableData.length; i++) {
          this.equipmentReport.tableData[i]['startupRateLabel'] = (this.equipmentReport.tableData[i]['startupRate'] / 100).toFixed(1) + '%';
          this.equipmentReport.tableData[i]['startupRateValue'] = (this.equipmentReport.tableData[i]['startupRate'] / 100).toFixed(1); // 开机率
          this.equipmentReport.tableData[i]['runRateLabel'] = (this.equipmentReport.tableData[i]['runRate'] / 100).toFixed(1) + '%';
          this.equipmentReport.tableData[i]['runRateValue'] = (this.equipmentReport.tableData[i]['runRate'] / 100).toFixed(1); // 稼动率
          this.equipmentReport.tableData[i]['runDuraLabel'] = (this.equipmentReport.tableData[i]['runDuration'] / 3600 / 1000).toFixed(1);
          this.equipmentReport.tableData[i]['idleDuraLabel'] = (this.equipmentReport.tableData[i]['idleDuration'] / 3600 / 1000).toFixed(1);
          this.equipmentReport.tableData[i]['errorDuraLabel'] = (this.equipmentReport.tableData[i]['errorDuration'] / 3600 / 1000).toFixed(1);
          this.equipmentReport.tableData[i]['shutdownDuraLabel'] = (this.equipmentReport.tableData[i]['shutdownDuration'] / 3600 / 1000).toFixed(1);
        }
        // 总开机率、总稼动率
        let runDuration = 0;
        let idleDuration = 0;
        let errorDuration = 0;
        let st = 0;

        for (let i = 0; i < this.equipmentReport.tableData.length; i++) {
          runDuration += this.equipmentReport.tableData[i]['runDuration'];
          idleDuration += this.equipmentReport.tableData[i]['idleDuration'];
          errorDuration += this.equipmentReport.tableData[i]['errorDuration'];
          st += this.equipmentReport.tableData[i]['st'];
        }

        this.startUpSumRate = (((runDuration + idleDuration + errorDuration) / 1000 / st) * 100).toFixed(1);
        let a = runDuration + idleDuration + errorDuration - (idleDuration + errorDuration);
        let b = runDuration + idleDuration + errorDuration;
        if (a !== 0) {
          this.jiadongSumRate = ((a / b) * 100).toFixed(1);
        } else {
          this.jiadongSumRate = '0.0';
        }
        // this.jiadongSumRate = (((runDuration + idleDuration + errorDuration) - (idleDuration +
        // 	errorDuration)) / (
        // 	runDuration + idleDuration + errorDuration) * 100).toFixed(1)
      } else {
        this.startUpSumRate = '0.0';
        // this.jiadongSumRate = '0.0'
      }

      // 图表部分
      let xAxis = [];
      let seriesStartUp = [];
      let seriseJiaDong = [];
      if (response.code == 200 && response.data.rows.length > 0) {
        xAxis = response.data.rows.map(item => {
          return item.equipmentName + ' ' + item.shiftName;
        });
        seriesStartUp = response.data.rows.map(item => {
          return item.startupRate / 100;
        });
        seriseJiaDong = response.data.rows.map(item => {
          return item.runRate / 100;
        });
      }
      this.produceeReportChart = this.echarts.init(document.getElementById('produceeReportMain'));
      let option = {
        tooltip: {
          trigger: 'axis',
          formatter(param) {
            let title = param[0]['axisValueLabel'];
            let label = '';
            for (let i = 0; i < param.length; i++) {
              label += '\n' + param[i]['marker'] + param[i]['seriesName'] + '   ' + param[i]['value'].toFixed(1) + '%' + '\n' + ' ';
            }
            return title + '\n' + label;
          },
          extraCssText: 'width:150px; white-space:pre-wrap;font-weight:bold'
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '60',
          top: '16%',
          containLabel: true
        },
        legend: {
          left: 'center',
          top: '5%',
          textStyle: {
            color: '#000'
          },
          itemWidth: 12,
          itemHeight: 12,
          itemGap: 32
        },
        dataZoom: [
          {
            show: true,
            height: 18,
            xAxisIndex: [0],
            bottom: 20,
            start: 10,
            end: 90,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '100%',
            handleStyle: {
              color: 'rgba(255, 255, 255,1'
            },
            textStyle: {
              color: '#909399',
              fontSize: 12
            },
            fillerColor: '#CBCED4',
            borderColor: 'rgba(255, 255, 255,1)',
            backgroundColor: '#F0F2F5',
            showDataShadow: true,
            brushSelect: false
          },
          {
            type: 'inside',
            disabled: false
          }
        ],
        xAxis: {
          show: true,
          type: 'category',
          nameLocation: 'end',
          nameTextStyle: {
            fontSize: 14
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed',
              color: '#000',
              width: 1
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: false,
            interval: 'auto',
            inside: false,
            length: 5,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399'
            }
          },
          axisLabel: {
            margin: 8,
            interval: 'auto',
            rotate: 0,
            fontSize: 14,
            color: '#909399'
          },
          data: xAxis
        },
        yAxis: {
          type: 'value',
          data: [0, 20, 40, 60, 80, 100],
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value} %'
          },
          nameTextStyle: {
            color: '#909399'
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              color: '#e4e7ed'
            }
          }
        },
        series: [
          {
            name: this.$t('kaijilv'),
            type: 'bar',
            barWidth: '12px',
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#5C41FF'
                  },
                  {
                    offset: 1,
                    color: 'rgba(227, 227, 227,0.3)'
                  }
                ]),
                barBorderRadius: 6
              }
            },
            data: seriesStartUp,
            barGap: '80%',
            barCategoryGap: '100%'
          },
          {
            name: this.$t('jiadonglv'),
            type: 'bar',
            barWidth: '12px',
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#419FFF'
                  },
                  {
                    offset: 1,
                    color: 'rgba(227, 227, 227,0.3)'
                  }
                ]),
                barBorderRadius: 6
              }
            },
            data: seriseJiaDong
          }
        ]
      };
      this.produceeReportChart.setOption(option);
      this.searchLoading = false;
    },
    // 导出基础效率
    exportExcelEff() {
      this.exportLoading = true;
      let requestParam = {};
      let param = [];
      for (let i in this.equipmentReport.searchForm) {
        if (this.equipmentReport.searchForm[i] != '') {
          let val = this.equipmentReport.searchForm[i];
          if (i == 'equipmentId') {
            val = this.equipmentReport.searchForm[i].join(',');
            param.push({
              field: 'equipmentId',
              opt: 'IN',
              val: val,
              type: 'S'
            });
          }
          if (i == 'summaryDate') {
            val = this.equipmentReport.searchForm[i].split('-').join('');
            param.push({
              field: 'summaryDate',
              opt: '=',
              val: val,
              type: 'S'
            });
          }
          if (i == 'orgId') {
            val = this.equipmentReport.searchForm[i].join(',');
            param.push({
              field: 'orgId',
              opt: 'IN',
              val: val,
              type: 'S'
            });
          }
          if (i == 'shiftId') {
            val = this.equipmentReport.searchForm[i].join(',');
            param.push({
              field: i,
              opt: 'IN',
              val: val,
              type: 'S'
            });
          }
        }
      }
      if (param.length > 0) {
        requestParam['columns'] = param;
      } else {
        requestParam['columns'] = [];
      }
      requestParam['code'] = 'equipment_basic_efficiency_export';
      return this.http
        .post('/web/report/export?orderBy=sort,shiftName,dt asc', requestParam)
        .then(response => {
          this.fildId = response.data;
          if (this.fildId) {
            return this.http
              .get('/web/report/work/get', {
                params: {
                  id: this.fildId
                }
              })
              .then(response => {
                this.exportLoading = false;
                this.fildIds = response.data.fileId;
                let status = response.data.status;
                if (status == 1) {
                  this.getDownload();
                  this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
                  this.$message.success(this.$t(response.msg));
                } else if (status == -1) {
                  this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
                  this.$message.success(this.$t(response.msg));
                } else if (status == 0 || null) {
                  this.timer = setInterval(() => {
                    this.getDownload();
                  }, 1000);
                }
              });
          } else {
            this.exportLoading = false;
          }
        })
        .catch(error => {
          this.$message.error(this.$t(error));
          this.exportLoading = false;
        });
    },
    getDownload() {
      console.log('this.fildIdthis.fildId', this.fildIds);
      return this.http.get('/web/customer/files/download?id=' + this.fildIds).then(res => {
        let baseUrl = res.data;
        if (res.data) {
          window.open(baseUrl);
        }
      });
    },
    // 重置效率月报
    reset() {
      this.equipmentReport.searchForm = {
        equipmentId: null,
        orgId: [],
        temp: '',
        summaryDate: current,
        shiftId: []
      };
      this.jiadongRate = undefined;
      this.startUpRate = undefined;
      // ++this.refreshOneKey
      this.$nextTick(() => {
        this.equipmentReport.searchForm.temp = this.store.state.organizations[0].id;
        this.$nextTick(() => {
          this.getReport();
        });
      });
      // this.getReport()
    },
    refresh(){
      this.$confirm(this.$t('本操作将生成上一天所有班次的效率与产量数据，建议在上一天所有班次结束时间后操作，是否确认刷新?'), this.$t('tishi'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning'
      }).then(() => {
        this.searchLoading = true;
        this.http.post('/web/equipment/basic/efficiency/refreshMonthlyReport').then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.getReport();
          this.isShowActionDialog = false;
        }).catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.searchLoading = false;
        });
      }).catch(() => {});
    },
    headerDragend(newWidth, oldWidth, column, event) {
      console.log('this.activeName', this.activeName);
      const name = 'producee_report_' + this.activeName;
      let colwidths = {};
      if (window.localStorage.getItem('colwidth_' + name)) {
        try {
          colwidths = JSON.parse(window.localStorage.getItem('colwidth_' + name));
        } catch (e) {
          window.localStorage.removeItem('colwidth_' + name);
        }
      }
      if (column.label == '' || column.label == null) {
        return;
      }
      colwidths[column.label] = column.width;
      window.localStorage.setItem('colwidth_' + name, JSON.stringify(colwidths));
    },
    // 显示报表详情
    showReportDetail(row) {
      this.reportDetail.dialog = true;
      this.reportDetail.title = this.$t(row.equipmentName) + ' ' + (row.summaryDate.slice(0, 4) + '-' + row.summaryDate.slice(4)) + ' ' + row.shiftName + ' ' + this.$t('baobiaoxiangqing');
      this.resize();
      this.$nextTick(() => {
        this.getChart(row);
      });
    },
    // 报表图表详情
    async getChart(row) {
      let requestParam = {
        columns: [
          {
            field: 'equipmentId',
            opt: '=',
            val: row.equipmentId,
            type: 'S'
          },
          {
            field: 'shiftId',
            opt: '=',
            val: row.shiftId,
            type: 'S'
          },
          {
            field: 'summaryDate',
            opt: '=',
            val: row.summaryDate,
            type: 'S'
          }
        ],
        code: 'equipment_basic_efficiency_report_details'
      };
      let pageParam = {
        orderBy: 'specificDate'
      };

      let response = await this.http.post('/web/report/page?' + this.qs.stringify(pageParam), requestParam);
      this.reportDetail.tableData = response.data.rows;
      if (this.reportDetail.tableData.length > 0) {
        for (let i = 0; i < this.reportDetail.tableData.length; i++) {
          this.reportDetail.tableData[i]['startupRateLabel'] = (this.reportDetail.tableData[i]['startupRate'] / 100).toFixed(1) + '%'; // 开机率
          this.reportDetail.tableData[i]['startupRateValue'] = (this.reportDetail.tableData[i]['startupRate'] / 100).toFixed(1) + '%'; // 开机率
          this.reportDetail.tableData[i]['runRateLabel'] = (this.reportDetail.tableData[i]['runRate'] / 100).toFixed(1) + '%'; // 稼动率
          this.reportDetail.tableData[i]['runRateValue'] = (this.reportDetail.tableData[i]['runRate'] / 100).toFixed(1) + '%'; // 稼动率
          this.reportDetail.tableData[i]['runDuraLabel'] = (this.reportDetail.tableData[i]['runDuration'] / 3600 / 1000).toFixed(1);
          this.reportDetail.tableData[i]['idleDuraLabel'] = (this.reportDetail.tableData[i]['idleDuration'] / 3600 / 1000).toFixed(1);
          this.reportDetail.tableData[i]['errorDuraLabel'] = (this.reportDetail.tableData[i]['errorDuration'] / 3600 / 1000).toFixed(1);
          this.reportDetail.tableData[i]['shutdownDuraLabel'] = (this.reportDetail.tableData[i]['shutdownDuration'] / 3600 / 1000).toFixed(1);
        }
      }

      // 图表部分
      let xAxis = [];
      let startupRate = [];
      let runRate = [];
      if (this.reportDetail.tableData.length > 0) {
        xAxis = this.reportDetail.tableData.map(item => {
          return item.specificDate;
        });
        startupRate = this.reportDetail.tableData.map(item => {
          return item.startupRate / 100;
        });
        runRate = this.reportDetail.tableData.map(item => {
          return item.runRate / 100;
        });
      }

      this.reportChart = this.echarts.init(document.getElementById('reportChartMain'));
      let option = {
        backgroundColor: '#fff',
        tooltip: {
          trigger: 'axis',
          formatter(param) {
            let title = param[0]['axisValueLabel'];
            let label = '';
            for (let i = 0; i < param.length; i++) {
              console.log(param[i]['marker']);
              label += '\n' + param[i]['marker'] + param[i]['seriesName'] + '   ' + param[i]['value'].toFixed(1) + '%' + '\n';
            }
            return title + '\n' + label;
          },
          extraCssText: 'width:150px; white-space:pre-wrap'
        },
        grid: {
          // left: '40',
          // right: '100',
          // bottom: '60',
          // top: '16%',
          // containLabel: true,
          top: '60',
          left: '40',
          right: '50',
          bottom: '60',
          containLabel: true
        },

        legend: {
          left: 'center',
          top: '5%',
          textStyle: {
            color: '#000'
          },

          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25
        },
        dataZoom: [
          {
            show: true,
            height: 18,
            xAxisIndex: [0],
            bottom: 20,
            start: 5,
            end: 95,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '100%',
            handleStyle: {
              color: 'rgba(255, 255, 255,1'
            },
            textStyle: {
              color: '#909399',
              fontSize: 12
            },
            fillerColor: '#CBCED4',
            borderColor: 'rgba(255, 255, 255,1)',
            backgroundColor: '#F0F2F5',
            showDataShadow: true,
            brushSelect: false
          },
          {
            type: 'inside',
            disabled: false
          }
        ],
        xAxis: {
          show: true,
          type: 'category',
          name: '',
          nameLocation: 'end',
          nameTextStyle: {
            fontSize: 14
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed',
              color: '#000',
              width: 1
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true,
            interval: 'auto',
            inside: false,
            length: 5,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399'
            }
          },
          axisLabel: {
            margin: 8,
            interval: 'auto',
            rotate: 0,
            fontSize: 14,
            color: '#909399'
          },
          data: xAxis
        },
        yAxis: {
          type: 'value',
          data: [0, 20, 40, 60, 80, 100],
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value} %'
          },
          nameTextStyle: {
            color: '#909399'
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              color: '#e4e7ed'
            }
          }
        },
        series: [
          {
            name: this.$t('kaijilv'),
            type: 'line',
            yAxisIndex: 0,
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: '#419fff'
              }
            },
            data: startupRate
          },

          {
            name: this.$t('jiadonglv'),
            type: 'line',
            yAxisIndex: 0,
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: '#5C41FF'
              }
            },

            data: runRate
          }
        ]
      };

      this.reportChart.setOption(option);
    },
    // 显示选择项
    showShowTableColumn(type) {
      this.showTableColumn.type = type;
      this.showTableColumn.dialog = true;
    },

    // 取消选择项
    cancelShowTableColumn() {
      this.showTableColumn.show = [...this.showTableColumn.initShow];
      this.showTableColumn.dialog = false;
    }
  }
};
</script>
